import { useAppSelector } from 'src/app/store';
import { useAssignmentsLocationsListQuery } from 'src/common/external/bambi-api/bambiApi';
import { selectCurrentAssignmentLocationId } from 'src/features/live-map/liveMap.slice';

export function useAssignmentLiveMapListViewModel() {
  const { data, isLoading, isFetching } = useAssignmentsLocationsListQuery({
    // TODO: This is still... not supposed to be necessary
    'Organization-ID': '1',
  });
  const selectedAssignmentLocationId = useAppSelector(
    selectCurrentAssignmentLocationId
  );

  return {
    assignmentLocations: data?.results,
    isLoading,
    isFetching,
    selectedAssignmentLocationId,
  };
}
